import React from 'react';
import VideoItem from './VideoItem';
//import { extractYouTubeVideoId } from '../util/util';
import './VideoList.css';

// 요청한 데이터를 정리하는 구간
const VideoList = ({ videos, onSelectVideo, selectedVideo, onMoreVideo, isLastPage }) => {
  const renderedList = videos && videos.map((video, index) => {
    //const videoId = extractYouTubeVideoId(video.youtube_url);
    return <VideoItem key={index} video={video} onSelectVideo={onSelectVideo} selectedVideo={selectedVideo}/>;
  });

  //console.log('isLastPage: ', isLastPage)

  return (
    <>
      <div className="ui relaxed divided list">
        {renderedList}
      </div>
      {/* <button className={`fluid ui button active ${isLastPage ? 'hidden' : ''}`}
        onClick={() => onMoreVideo()}>더 보기
      </button> */}
    </>
  );
}

export default VideoList;
